import { Tooltip, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ADVANTAGES } from './constants';
import { clsx } from 'clsx';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { SubTitle } from 'shared/components/SubTitle';
import { Description } from 'shared/components/Description';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const PaidServicesAndBenefits: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.PaidServices}>
          <Block>
            <SubTitle text="Услуги продвижения" />
            <Description
              text={[
                { value: 'Для повышения заметности объявлений доступны платные инструменты продвижения ' },
                { value: 'Value Added Services (VAS).', isBold: true },
                {
                  value: ` Их можно подключать отдельно или в составе пакетов и подписок. Для удобства предусмотрены автосценарии — автоматическое управление продвижением.`,
                },
              ]}
            />
          </Block>
        </Element>
        <Element name={ENavigation.BenefitsCpt}>
          <div className={styles['advantages']}>
            <SubTitle text="Преимущества СРТ-модели для бизнеса" />
            <div className={styles['list']}>
              {ADVANTAGES.map(({ title, notice }, key) => (
                <div className={styles['item']} key={key}>
                  <div className={styles['list-title']}>{title}</div>
                  <Tooltip theme="white" title={notice}>
                    <div className={styles['notice']} />
                  </Tooltip>
                </div>
              ))}
            </div>
          </div>
        </Element>
      </Wrapper>
    </div>
  );
};
